export const IMAGES = [
  {
    src: "https://i.ibb.co/6PQ6sxW/class-501-pic-B1.jpg", thumbnail: "",
  },
  {
    src: "https://i.ibb.co/CJ4tKDK/class-501-pic-B2.jpg", thumbnail: "",
  },
];
